/** Where each role starts before the workspace is known; `roleHomePath` refines it once the workspace kind is. Kept free of
 * imports so the landing route can use it without loading the app. */
const ROLE_ENTRY: Record<string, string> = {
  manager: '/manager/dashboard',
  property_manager: '/property-manager/properties',
  investor: '/no-access',
  accountant: '/manager/accounting',
  attorney: '/no-access',
  director: '/manager/board',
  front_desk: '/desk/visitors',
};

export function roleEntryPath(role: string | null | undefined): string | undefined {
  return role ? ROLE_ENTRY[role] : undefined;
}

/** A manager who signed up but has no workspace yet finishes onboarding; everyone else goes to their role's start. */
export function startPathFor(user: { role: string; onboardingCompleted?: boolean | null; fundId?: string | null }): string {
  if (user.role === 'manager' && !user.onboardingCompleted && !user.fundId) return '/onboarding/about-you';
  return roleEntryPath(user.role) ?? '/login';
}
